﻿import {translation} from "@2d-front-monorepo/core";
import {MaterialIcon, Message, PopOver, TabPanel, Tabs} from "@2d-front-monorepo/design-library";
import {AttachmentsComponent, VehicleResult, VehicleType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX, useMemo} from "react";
import {Link} from "react-router";
import {API_ENDPOINT} from "../../api-endpoint";
import {VehicleComponent} from "../../components/VehicleComponent";
import {usePermits} from "../../hooks/usePermits";
import {formatRoute, PrivateRoutes} from "../../routes";

const filesPrefix = API_ENDPOINT.fileDownload;

function VehicleCard({vehicle}: { vehicle: VehicleResult }): JSX.Element {
	return <div className="card layout horizontal aligned top">
		<details className="flex">
			<summary><VehicleComponent vehicle={vehicle}/></summary>
			<div>
				<div className="columns gap padded">
					<dl className="title-desc col25">
						<dt>{translation(PermitTranslations.vehicle__type)}</dt>
						<dd>{vehicle.data?.type || "—"}</dd>
					</dl>
					<dl className="title-desc col25">
						<dt>{translation(PermitTranslations.vehicle__color)}</dt>
						<dd>{vehicle.data?.color || "—"}</dd>
					</dl>
					<AttachmentsComponent entity={vehicle} className="col50" linkPrefix={filesPrefix}/>
				</div>
			</div>
		</details>
		<div className="padded block start">
			<PopOver>
				<Link to={formatRoute(PrivateRoutes.vehiclesEdit, vehicle.id)}>
					<MaterialIcon icon="edit"/>
					{translation(PermitTranslations.edit)}
				</Link>
			</PopOver>
		</div>
	</div>
}

function VehicleList({vehicles}: { vehicles: VehicleResult[] }): JSX.Element {
	if (vehicles.length == 0) {
		return <Message title={{text: translation(PermitTranslations.vehicles_page__no_vehicles)}} type="information"/>
	}
	return <div className="layout vertical gap">
		{vehicles.map(vehicle => <VehicleCard vehicle={vehicle} key={vehicle.id}/>)}
	</div>;
}

export default function Vehicles(): JSX.Element {
	const {permits} = usePermits();
	const residentVehicles = useMemo(() => permits.vehicles.filter(x => x.type === VehicleType.Resident), [permits]);
	const visitorVehicles = useMemo(() => permits.vehicles.filter(x => x.type === VehicleType.Visitor), [permits]);

	return (
		<>
			<h1>{translation(PermitTranslations.vehicles)}</h1>
			<Tabs>
				<TabPanel title={translation(PermitTranslations.vehicles_page__residents)}>
					<VehicleList vehicles={residentVehicles}/>
				</TabPanel>
				<TabPanel title={translation(PermitTranslations.vehicles_page__visitors)}>
					<VehicleList vehicles={visitorVehicles}/>
				</TabPanel>
			</Tabs>
		</>
	)
}
